import { mapState, mapMutations, mapGetters } from 'vuex'
import langCodes from './langCodes.mixin.js'

export default {
  data: () => ({
    sourceItem: {},
  }),
  mixins: [langCodes],
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      dubbingGeneratingData: (state) => state.video.dubbingData.fetching,
      subtitleGeneratingData: (state) => state.video.subtitleData.fetching,
    }),
    ...mapGetters('video', ['activeAudios']),
    availableAiLangCodes() {
      return this.langCodes.filter(({ srclang }) =>
        ['pt-BR', 'en', 'es', 'fr', 'de', 'it'].includes(srclang)
      )
    },
    availableTranscriptionLangCodes() {
      return [
        {
          label: 'Auto',
          srclang: 'auto',
          country: 'auto',
        },
        ...this.availableAiLangCodes,
      ]
    },
    unusedDubbingLangCodesAi: {
      get() {
        if (this.video?.original_lang) {
          return this.getUnusedDubbingItems(this.availableAiLangCodes)
        }
        return this.unusedDubbingForTranscription
      },
      cache: false,
    },
    unusedDubbingForTranscription() {
      return this.getUnusedDubbingItemsForSubtitlesGen(
        this.availableAiLangCodes
      )
    },
    unusedSubLangCodesAi() {
      return this.getUnusedSubtitleItems(this.availableAiLangCodes)
    },
  },
  methods: {
    ...mapMutations('video', [
      'UPDATE_AUDIO_LIST',
      'UPDATE_GENERATING_DUBBING_DATA',
      'UPDATE_GENERATING_SUBTITLE_DATA',
      'UPDATE_VIDEO_ORIGINAL_LANG',
    ]),
    checkIfListItemIsSource(item) {
      return this.sourceItem.srclang === item.srclang
    },
    getUnusedDubbingItems(sourceList) {
      const currentPublishedAudios = this.activeAudios.length
        ? this.activeAudios.map((item) => item.lang)
        : []
      const currentVideoAudios = this.video?.audios
        ? this.video.audios.map((item) => item.lang)
        : []
      return sourceList.filter(
        (item) =>
          !currentPublishedAudios.includes(item.srclang) &&
          !currentVideoAudios.includes(item.srclang) &&
          !this.dubbingGeneratingData.find(
            (sub) =>
              sub.metadata?.to_lang === item.srclang ||
              sub.metadata.from_lang === item.srclang
          ) &&
          this.isNotBlockedAsOriginalLang(item)
      )
    },
    getUnusedDubbingItemsForSubtitlesGen(sourceList) {
      const currentPublishedAudios = this.activeAudios.length
        ? this.activeAudios.map((item) => item.lang)
        : []
      return sourceList.filter(
        (item) =>
          !currentPublishedAudios.includes(item.srclang) &&
          !this.dubbingGeneratingData.find(
            (sub) =>
              sub.metadata?.to_lang === item.srclang ||
              sub.metadata.from_lang === item.srclang
          )
      )
    },
    isNotBlockedAsOriginalLang(item) {
      const originalLang = this.video?.original_lang ?? ''

      if (item.srclang !== originalLang) {
        return true
      } else {
        return false
      }
    },
    getUnusedSubtitleItems(sourceList) {
      const currentPublishedSubs = this.subtitles.map((item) => {
        if (item.srclang === 'pt' || item.srclang === 'pt-BR') return 'pt-BR'
        return this.getPreparedSrcLang(item.srclang)
      })
      return sourceList.filter(
        (item) =>
          !currentPublishedSubs.includes(item.srclang) &&
          !this.subtitleGeneratingData.find(
            (sub) =>
              sub.metadata?.to_lang === item.srclang ||
              sub.metadata.from_lang === item.srclang
          )
      )
    },
    containsDuplicates(array) {
      if (array.length !== new Set(array).size) {
        return true
      }

      return false
    },
    getLangLabelBySrclang(srclang) {
      srclang = this.getPreparedSrcLang(srclang)
      if (srclang === 'auto') return 'Auto'
      if (srclang === 'pt') return 'pt-BR'
      return this.langCodes.filter((lang) => {
        return lang.srclang === srclang
      })[0].label
    },
    areStringsEqualIgnoringCaseAndSymbols(str1, str2) {
      const cleanString = (str) => str.replace(/[^\w\s]/g, '').toLowerCase()
      const cleanedStr1 = cleanString(str1)
      const cleanedStr2 = cleanString(str2)
      return cleanedStr1 === cleanedStr2 || cleanedStr2.includes(cleanedStr1)
    },
  },
}
